import React, { useEffect, useState } from "react";
import FormModal from "../../Modals/FormModal";
import SelectField from "../../Forms/Input/SelectField";
import FileUploader from "../../Uploader/FileUploader";
import InputField from "../../Forms/Input/InputField"; // ✅ Se usa el componente estándar
import clsx from "clsx";
import { QzTrayCertificateType } from "../../../types/qztray/QzTrayCertificateTypes";

interface Props {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (
    file: File,
    type: QzTrayCertificateType,
    password?: string,
    alias?: string
  ) => void;
  initialType: QzTrayCertificateType | null;
  isSubmitting: boolean;
}

const QzTrayCertificateEditModal: React.FC<Props> = ({
  isOpen,
  onClose,
  onSubmit,
  initialType,
  isSubmitting,
}) => {
  const [file, setFile] = useState<File | null>(null);
  const [password, setPassword] = useState("");
  const [alias, setAlias] = useState("");

  // 🔄 Limpiar estado al abrir el modal
  useEffect(() => {
    if (isOpen) {
      setFile(null);
      setPassword("");
      setAlias("");
    }
  }, [isOpen]);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!initialType || !file) return;
    onSubmit(file, initialType, password, alias);
  };

  const getTitle = () => {
    switch (initialType) {
      case "PEM":
        return "Actualizar Certificado PEM";
      case "P12":
        return "Actualizar Certificado P12 / PFX";
      case "CRT":
        return "Actualizar Certificado CRT";
      case "CER":
        return "Actualizar Certificado CER";
      default:
        return "Actualizar Certificado";
    }
  };

  return (
    <FormModal
      isOpen={isOpen}
      onClose={onClose}
      title={getTitle()}
      maxWidth="max-w-xl"
    >
      <form onSubmit={handleSubmit} className="mt-4 grid grid-cols-1 gap-6">
        {/* 🔹 Tipo de certificado */}
        <SelectField
          label="Tipo de Certificado"
          name="type"
          value={initialType || ""}
          onChange={() => {}}
          options={[
            { label: "Clave Privada PEM (.pem)", value: "PEM" },
            { label: "Certificado P12 (.p12 / .pfx)", value: "P12" },
            { label: "Certificado CRT (.crt)", value: "CRT" },
            { label: "Certificado CER (.cer)", value: "CER" },
          ]}
          disabled={true}
          iconKey="list"
        />

        {/* 🔹 Archivo nuevo */}
        <FileUploader
          currentFile={file}
          onFileChange={setFile}
          onRemoveFile={() => setFile(null)}
          label="Seleccione nuevo archivo de certificado"
          accept=".pem,.p12,.pfx,.crt,.cer"
          iconKey="upload"
        />

        {/* 🔹 Contraseña (solo para P12) */}
        {initialType === "P12" && (
          <InputField
            label="Contraseña del certificado (si aplica)"
            name="password"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Ingrese contraseña del certificado"
            iconKey="lock"
          />
        )}

        {/* 🔹 Alias (opcional) */}
        <InputField
          label="Alias del certificado (opcional)"
          name="alias"
          type="text"
          value={alias}
          onChange={(e) => setAlias(e.target.value)}
          placeholder="Ingrese un alias identificador"
          iconKey="user"
        />

        {/* 🔹 Botón de acción */}
        <button
          type="submit"
          disabled={isSubmitting}
          className={clsx(
            "w-full rounded px-4.5 py-2.5 font-medium text-white",
            isSubmitting
              ? "bg-gray-400 cursor-not-allowed"
              : "bg-primary hover:bg-opacity-90"
          )}
        >
          {isSubmitting ? "Actualizando..." : "Actualizar Certificado"}
        </button>
      </form>
    </FormModal>
  );
};

export default QzTrayCertificateEditModal;
